"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccelerationUnitSchema = void 0;
const zod_1 = require("zod");
exports.AccelerationUnitSchema = zod_1.z.enum(['m_s2', 'ft_s2']);
exports.default = exports.AccelerationUnitSchema;
//# sourceMappingURL=AccelerationUnitSchema.js.map